import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ig-loading-dot',
  templateUrl: './loading.dot.component.html',
  styleUrls: ['./loading.dot.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoadingDotComponent implements OnInit {
  @Input() loadingTips = [''];

  tip: string = '';

  ngOnInit(): void {
    this.tip = this.loadingTips.getRandom();

    if (this.loadingTips.length > 1) {
      setInterval(() => {
        this.selectTip();
      }, 5000);
    }
  }

  selectTip() {
    let selected = this.loadingTips.getRandom();
    while (selected === this.tip) {
      selected = this.loadingTips.getRandom();
    }
    this.tip = selected;
  }
}
